<template>
  <div class="breadcrumb">
    <ul>
      <li v-for="(dir, index) in directoryList" :key="index">
        <a @click.prevent="click(index)">
          <i class="icon" /> {{ dir }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { isEmpty, compact } from 'lodash-es'
import { mapGetters } from 'vuex'
import eventBus from '@/modules/eventBus'

export default {
  computed: {
    ...mapGetters(['treeNodes', 'currentDirectory']),

    // Explode current directory into array
    directoryList () {
      if (!isEmpty(this.currentDirectory)) {
        return ['/', ...compact(this.currentDirectory.split('/'))]
      } else {
        return ['/']
      }
    }
  },

  methods: {
    async click (index) {
      // Calulate directory from index
      let directory = '/' + this.directoryList.slice(1, index + 1).join('/') + '/'
      let treeNode

      if (directory === '//') {
        // Root node
        directory = '/'
        treeNode = this.treeNodes
      } else {
        // Find node in tree
        treeNode = this.$utils.findInTree(this.treeNodes.children, directory)
      }

      // Reset selection
      eventBus.$emit('fileExplorer:unselect')

      // Send naviagtion event
      eventBus.$emit('fileExplorer:navigate')

      // Reset selected item as we are openning a folder
      this.$store.commit('setSelectedElement', null)

      // Create directory from clicked element
      // Use nextTick to let the cancelNewFolder finish
      await this.$nextTick()
      this.$store.dispatch('getDirectory', {
        directory: directory,
        parentNode: treeNode,
        changeCurrentDirectory: true
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .breadcrumb {
    padding: 5px;
    margin-bottom: 15px;
    font-size: 12px;
    color: $primary;
    background: $gray-300;
    border-radius: $border-radius;

    ul {
      padding: 0;
      margin: 0;
      list-style: none;

      li {
        display: inline;
        margin-right: 10px;

        a {
          color: $primary;
          cursor: pointer;

          i.icon {
            display: inline-block;
            width: 21px;
            height: 21px;
            padding: 0;
            margin: 0;
            line-height: 0;
            vertical-align: bottom;
            background-color: transparent;
            background-image: url("~@/img/file-explorer.png");
            background-repeat: no-repeat;
            background-attachment: scroll;
            background-position: -147px 0;
            border: 0 none;
            outline: none;
          }
        }
      }
    }
  }
</style>
